import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import "./style.scss";

const WalletIcon = () => (
	<svg
		width="40"
		height="40"
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			d="M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z"
			fill="#00D1FF"
			fillOpacity="0.1"
		/>
		<path
			d="M27.5 16.6667H13.3333C12.4129 16.6667 11.6667 17.4129 11.6667 18.3333V26.6667C11.6667 27.5871 12.4129 28.3333 13.3333 28.3333H27.5C28.4205 28.3333 29.1667 27.5871 29.1667 26.6667V18.3333C29.1667 17.4129 28.4205 16.6667 27.5 16.6667Z"
			stroke="#00D1FF"
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M11.6667 20H29.1667"
			stroke="#00D1FF"
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M15.8333 11.6667H24.1667"
			stroke="#00D1FF"
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M13.3333 11.6667L11.6667 16.6667"
			stroke="#00D1FF"
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M26.6667 11.6667L28.3333 16.6667"
			stroke="#00D1FF"
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<circle cx="24.1667" cy="23.3333" r="1.25" fill="#00D1FF" />
	</svg>
);

const WalletBlackIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			d="M16.6667 8.33331H6.66667C5.74619 8.33331 5 9.07951 5 9.99998V15.8333C5 16.7538 5.74619 17.5 6.66667 17.5H16.6667C17.5871 17.5 18.3333 16.7538 18.3333 15.8333V9.99998C18.3333 9.07951 17.5871 8.33331 16.6667 8.33331Z"
			stroke="#0B0F14"
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M5 11.6667H18.3333"
			stroke="#0B0F14"
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M8.33333 5.83331H14.1667"
			stroke="#0B0F14"
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M6.66667 5.83331L5 8.33331"
			stroke="#0B0F14"
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M15 5.83331L16.6667 8.33331"
			stroke="#0B0F14"
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<circle cx="14.1667" cy="13.3333" r="1.25" fill="#0B0F14" />
	</svg>
);

const HomeIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			d="M12.5 17.5V10.8333C12.5 10.6123 12.4122 10.4004 12.2559 10.2441C12.0996 10.0878 11.8877 10 11.6667 10H8.33333C8.11232 10 7.90036 10.0878 7.74408 10.2441C7.5878 10.4004 7.5 10.6123 7.5 10.8333V17.5"
			stroke="white"
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M2.5 8.33335C2.49994 8.0909 2.55278 7.85137 2.65482 7.63144C2.75687 7.41152 2.90566 7.21651 3.09083 7.06001L8.92417 2.06085C9.22499 1.8066 9.60613 1.66711 10 1.66711C10.3939 1.66711 10.775 1.8066 11.0758 2.06085L16.9092 7.06001C17.0943 7.21651 17.2431 7.41152 17.3452 7.63144C17.4472 7.85137 17.5001 8.0909 17.5 8.33335V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0119C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0119C2.67559 16.6993 2.5 16.2754 2.5 15.8333V8.33335Z"
			stroke="white"
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const ConfirmCharge = () => {
	const { t } = useTranslation();
	const history = useHistory();
	const { search } = useLocation();
	const amount = new URLSearchParams(search).get("amount");

	return (
		<div className="home">
			<div className="confirm-booking">
				<div className="container">
					<div className="circle"></div>
					<p className="page-title">{t("Wallet Charged!")}</p>
					<p className="description">
						{t("Your wallet has been topped up successfully")}
					</p>

					<div className="booking-data">
						<div className="details">
							<WalletIcon />
							<div>
								<p className="label">{t("Amount Added")}</p>
								<p className="value">
									{Number(amount)?.toFixed(3)} {t("KWD")}
								</p>
							</div>
						</div>
					</div>

					<div className="confirm-buttons" style={{ marginTop: "32px" }}>
						<button
							className="view-bookings"
							onClick={() => history.push("/my-wallet")}>
							<WalletBlackIcon />
							{t("Go to My Wallet")}
						</button>
						<button
							className="back-games"
							onClick={() => history.push("/games")}>
							<HomeIcon />
							{t("Back to Games")}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};
export default ConfirmCharge;
